import React, { useContext } from 'react';
import { TooltipStyled } from './styles';
import { ContextoListaApartamentos } from '../ApartamentList/contextoImoveis';

function TooltipStandard(props) {
  const { tema } = useContext(ContextoListaApartamentos);

  return props?.hide === true ? (
    <>{props.children}</>
  ) : (
    <TooltipStyled color={tema?.primaryColor} {...props} />
  );
}

export default TooltipStandard;
